import { takeLatest, put, select } from 'redux-saga/effects';

import { appInit } from './actions';
import {
  authInitRequest,
  authInitSuccess,
  logInSuccess,
  refreshSuccess,
} from '../auth/actions';
import { TokenSet } from '../auth/types';
import { selectAuthTokens } from '../auth/selectors';
import apiService from '../../../services/ApiService';
import { getCurrentUserRequest } from '../users/actions';

function* authInit() {
  yield put(authInitRequest());
}

function* initApiService() {
  const { access }: TokenSet = yield select(selectAuthTokens);
  apiService.setToken(access);
}

function* loadCurrentUser() {
  yield put(getCurrentUserRequest());
}

export default [
  takeLatest(appInit.type, authInit),
  takeLatest([authInitSuccess.type, logInSuccess.type], loadCurrentUser),
  takeLatest([authInitSuccess.type, logInSuccess.type, refreshSuccess.type], initApiService),
];
